import {StringParam, withDefault} from 'use-query-params';
import {rangeTypes} from 'common/utils/dateRangeService';

const EMPTY_ARRAY = [];

export const PARAMS_NAME = {
  CONST_RANGE: 'constRange',
  USERS: 'userId',
  ACTION_TYPE: 'actionType',
  ACTIVITY: 'entityType',
  ALERT: 'alert',
  STREAM: 'stream',
  CHANNEL: 'channel',
  SOURCE: 'source',
  PIPELINE: 'pipeline',
  USER: 'user',
  USER_GROUP: 'group',
};

export const ACTIVITY_PARAMS = [
  PARAMS_NAME.ALERT,
  PARAMS_NAME.STREAM,
  PARAMS_NAME.CHANNEL,
  PARAMS_NAME.SOURCE,
  PARAMS_NAME.PIPELINE,
  PARAMS_NAME.USER,
  PARAMS_NAME.USER_GROUP,
];

export const DEFAULT_PARAMS = {
  [PARAMS_NAME.CONST_RANGE]: rangeTypes.w1.value,
  [PARAMS_NAME.USERS]: undefined,
  [PARAMS_NAME.ACTION_TYPE]: undefined,
  [PARAMS_NAME.ACTIVITY]: undefined,
  [PARAMS_NAME.ALERT]: undefined,
  [PARAMS_NAME.STREAM]: undefined,
  [PARAMS_NAME.CHANNEL]: undefined,
  [PARAMS_NAME.SOURCE]: undefined,
  [PARAMS_NAME.PIPELINE]: undefined,
  [PARAMS_NAME.USER]: undefined,
  [PARAMS_NAME.USER_GROUP]: undefined,
};

export const DEFAULT_PARAMS_CONFIG = {
  [PARAMS_NAME.CONST_RANGE]: withDefault(StringParam, rangeTypes.w1.value),
  [PARAMS_NAME.USERS]: StringParam,
  [PARAMS_NAME.ACTION_TYPE]: StringParam,
  [PARAMS_NAME.ACTIVITY]: StringParam,
  [PARAMS_NAME.ALERT]: StringParam,
  [PARAMS_NAME.STREAM]: StringParam,
  [PARAMS_NAME.CHANNEL]: StringParam,
  [PARAMS_NAME.SOURCE]: StringParam,
  [PARAMS_NAME.PIPELINE]: StringParam,
  [PARAMS_NAME.USER]: StringParam,
  [PARAMS_NAME.USER_GROUP]: StringParam,
};

export const ACTION_TYPE_VALUE = {
  CREATE: 'CREATE',
  EDIT: 'MODIFY',
  DELETE: 'DELETE',
};

export const OPTIONS_ACTION_TYPE = [
  {
    label: 'Edit',
    value: ACTION_TYPE_VALUE.EDIT,
  },
  {
    label: 'Create',
    value: ACTION_TYPE_VALUE.CREATE,
  },
  {
    label: 'Delete',
    value: ACTION_TYPE_VALUE.DELETE,
  },
];

export const ACTIVITY_VALUE = {
  ALL: 'All',
  ALERTS: 'ALERT',
  CHANNELS: 'CHANNEL',
  DATA_STREAMS: 'BC_STREAM',
  DATA_SOURCE: 'BC_DATA_SOURCE',
  PIPELINE: 'PIPELINE',
  USER: 'USER',
  USER_GROUP: 'USER_GROUP',
};

export const SYSTEM_USER = {
  label: 'Anodot',
  value: 'SYSTEM',
};

export const getNameActivityType = (value) => {
  switch (value) {
    case ACTIVITY_VALUE.ALERTS:
      return PARAMS_NAME.ALERT;
    case ACTIVITY_VALUE.DATA_STREAMS:
      return PARAMS_NAME.STREAM;
    case ACTIVITY_VALUE.CHANNELS:
      return PARAMS_NAME.CHANNEL;
    case ACTIVITY_VALUE.DATA_SOURCE:
      return PARAMS_NAME.SOURCE;
    case ACTIVITY_VALUE.PIPELINE:
      return PARAMS_NAME.PIPELINE;
    case ACTIVITY_VALUE.USER:
      return PARAMS_NAME.USER;
    case ACTIVITY_VALUE.USER_GROUP:
      return PARAMS_NAME.USER_GROUP;
    default:
      return null;
  }
};

export const getActivityTypeByParamName = (value) => {
  switch (value) {
    case PARAMS_NAME.ALERT:
      return ACTIVITY_VALUE.ALERTS;
    case PARAMS_NAME.STREAM:
      return ACTIVITY_VALUE.DATA_STREAMS;
    case PARAMS_NAME.CHANNEL:
      return ACTIVITY_VALUE.CHANNELS;
    case PARAMS_NAME.SOURCE:
      return ACTIVITY_VALUE.DATA_SOURCE;
    case PARAMS_NAME.PIPELINE:
      return ACTIVITY_VALUE.PIPELINE;
    case PARAMS_NAME.USER:
      return ACTIVITY_VALUE.USER;
    case PARAMS_NAME.USER_GROUP:
      return ACTIVITY_VALUE.USER_GROUP;
    default:
      return null;
  }
};

export const OPTIONS_ACTIVITY_TYPE = [
  {
    label: 'All',
    value: ACTIVITY_VALUE.ALL,
  },
  {
    label: 'Alerts',
    value: ACTIVITY_VALUE.ALERTS,
  },
  {
    label: 'Channels',
    value: ACTIVITY_VALUE.CHANNELS,
  },
  {
    label: 'Data Streams',
    value: ACTIVITY_VALUE.DATA_STREAMS,
  },
  {
    label: 'Data Sources',
    value: ACTIVITY_VALUE.DATA_SOURCE,
  },
  {
    label: 'Pipelines',
    value: ACTIVITY_VALUE.PIPELINE,
  },
  {
    label: 'Users',
    value: ACTIVITY_VALUE.USER,
  },
  {
    label: 'Groups',
    value: ACTIVITY_VALUE.USER_GROUP,
  },
];

export const getLabel = (options, value) =>
  (options.flatMap((o) => (value.includes(o.value) ? [o.label] : [])) || EMPTY_ARRAY).join(', ');

export const getOptionsMenuRow = (activityValue, userName, actionType) => {
  const options = [
    {
      value: activityValue,
      label: `Show only this ${activityValue}`,
    },
    {
      value: PARAMS_NAME.USERS,
      label: `Show only from user ${userName}`,
    },
  ];

  if (actionType === ACTION_TYPE_VALUE.EDIT) {
    options.unshift({
      value: ACTION_TYPE_VALUE.EDIT,
      label: 'Change Log',
    });
  }

  return options;
};

export const getNameActionType = (value) => {
  switch (value) {
    case ACTION_TYPE_VALUE.CREATE:
      return 'created';

    case ACTION_TYPE_VALUE.EDIT:
      return 'edited';

    case ACTION_TYPE_VALUE.DELETE:
      return 'deleted';

    default:
      return '';
  }
};

export const getEntityTypeText = ({actionType, entityType, entityDefinition}) => {
  if (entityType === ACTIVITY_VALUE.CHANNELS && actionType === ACTION_TYPE_VALUE.CREATE) {
    return `a new ${entityDefinition.channelMeta.type} channel`;
  }

  if (entityType === ACTIVITY_VALUE.CHANNELS) {
    return `${entityDefinition.channelMeta.type} channel`;
  }

  if (actionType === ACTION_TYPE_VALUE.CREATE) {
    return `a new ${getNameActivityType(entityType)}`;
  }

  return `the ${getNameActivityType(entityType)}`;
};
